import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { useInsertUserMasterMutation } from "AppQuries/user/user-master";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { userMasterValidation } from "core/Operations/ValidationSchema/userValidationSchema";
import UserMasterForm from "Components/Form/UserMasterForm";
import { toast } from "core/Operations/toast";

const AddUserMaster = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addUserMaster,
    isPending,
    isError,
    error,
  } = useInsertUserMasterMutation();

  const methods = useForm({
    defaultValues: {
      companyCode: userData?.companyCode,
      createUser: userData?.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      locationCode: userData?.locationCode,
      isActive: true,
      isLock: false,
      appPin: "",
    },
    resolver: yupResolver(userMasterValidation),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (payload) => {
    const requestData = [{ ...payload }];
    addUserMaster(requestData, {
      onSuccess: (data) => {
        if (data?.response === true) {
          toast.success(data?.errorMessage || "User Master Added Successfully.");

          // setTimeout(() => {
            navigate(`${all_routes.user_master}${all_routes.user_master_list}`);
          // }, 1000);
        } else {
          toast.warning(data?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add User Master</h4>
                    <h6>Add your Users </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.user_master}${all_routes.user_master_list}`}
                      className="btn btn-secondary"
                    >
                      {/* <ArrowLeft className="me-2" /> */}
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Save User Master</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add User Master</h4>
                    </div>
                    <div className="card-body">
                      <UserMasterForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddUserMaster;
